import styled from 'styled-components';

const StyledHr = styled.div`
  width: 100%;
  margin: 12px 0 !important;
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
`;

export default StyledHr;
